import { ReturnZod } from "../return";

export enum ExternalIntegrationIdProviders {
  AIMS360 = "aims360",
  APPAREL_MAGIC = "apparelmagic",
  BRIGHTPEARL = "brightpearl",
  CLOUDX = "cloudx",
  EXTENSIV = "extensiv",
  FLEXPORT = "flexport",
  NETSUITE = "netsuite",
  SFOM = "sfom",
  SHIPBOB = "shipbob",
  SHIPEDGE = "shipedge",
  SHIPHERO = "shiphero",
  TRACKSTAR = "trackstar",
  RETURNBEAR = "returnbear",
  BLUEYONDER = "blueyonder",
  INMAR = "inmar",
}

export enum ExternalIntegrationIdTypes {
  // Primary return document
  RMA = "rma",

  // Support documents
  SUPPORT_CASE = "support_case",

  // Financial documents
  // CASH_REFUND = "cash_refund",
  CREDIT_MEMO = "credit_memo",
  REFUND = "refund",
  SALES_CREDIT = "sales_credit",

  // Fulfillment documents
  RECEIPT = "receipt",
  SALES_ORDER = "sales_order",

  // Physical package identifiers
  BOX = "box",
}

export type ExternalIntegrationId = NonNullable<
  ReturnZod["externalIntegrationIds"]
>[number];

export interface FindExternalIntegrationIdParams {
  provider: ExternalIntegrationIdProviders;
  type: ExternalIntegrationIdTypes;
  shipmentGroupId?: string;
  id?: string;
}

function matchesExternalIntegrationIdParams(
  extId: ExternalIntegrationId,
  params: FindExternalIntegrationIdParams,
): boolean {
  if (extId.provider !== params.provider) {
    return false;
  }
  if (extId.type !== params.type) {
    return false;
  }
  if (
    params.shipmentGroupId !== undefined &&
    extId.shipmentGroupId !== params.shipmentGroupId
  ) {
    return false;
  }
  if (params.id !== undefined && extId.id !== params.id) {
    return false;
  }
  return true;
}

export function findExternalIntegrationId(
  externalIntegrationIds: ExternalIntegrationId[] | undefined | null,
  params: FindExternalIntegrationIdParams,
): ExternalIntegrationId | undefined {
  if (!externalIntegrationIds) {
    return undefined;
  }
  return externalIntegrationIds.find((extId) =>
    matchesExternalIntegrationIdParams(extId, params),
  );
}

export function filterExternalIntegrationIds(
  externalIntegrationIds: ExternalIntegrationId[] | undefined | null,
  params: FindExternalIntegrationIdParams,
): ExternalIntegrationId[] {
  if (!externalIntegrationIds) {
    return [];
  }
  return externalIntegrationIds.filter((extId) =>
    matchesExternalIntegrationIdParams(extId, params),
  );
}

export function hasExternalIntegrationId(
  externalIntegrationIds: ExternalIntegrationId[] | undefined | null,
  params: FindExternalIntegrationIdParams,
): boolean {
  return (
    findExternalIntegrationId(externalIntegrationIds, params) !== undefined
  );
}
